import React, { useRef } from "react";
import { FaHandsHelping, FaShareAlt, FaMoneyBillWave } from "react-icons/fa";
import { motion, useInView } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const FundraiserSteps = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true }); // Trigger animation when in view

  return (
    <motion.div
      className="min-h-screen bg-white flex flex-col items-center justify-center p-12"
      ref={sectionRef}
    >
      {/* Heading */}
      <motion.h1
        className="text-4xl font-bold text-center mb-10 text-gray-800"
        initial={{ opacity: 0, y: -50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1.5 }}
      >
        Start a Fundraiser in Three Simple Steps
      </motion.h1>

      {/* Steps Section */}
      <div className="grid md:grid-cols-3 gap-10 w-full max-w-5xl">
        {/* Step 1 */}
        <motion.div
          className="bg-white p-8 shadow-lg rounded-lg flex flex-col items-center text-center"
          variants={cardVariants}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1.5 }}
        >
          <div className="w-16 h-16 flex items-center justify-center bg-blue-100 text-blue-600 rounded-full mb-6">
            <FaHandsHelping size={30} />
          </div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Start Your Fundraiser
          </h2>
          <p className="text-gray-600">
            It’ll take only 2 minutes. Just tell us a few details about you and
            the ones you are raising funds for.
          </p>
        </motion.div>

        {/* Step 2 */}
        <motion.div
          className="bg-white p-8 shadow-lg rounded-lg flex flex-col items-center text-center"
          variants={cardVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          transition={{ delay: 0.8 }}
        >
          <div className="w-16 h-16 flex items-center justify-center bg-green-100 text-green-600 rounded-full mb-6">
            <FaShareAlt size={30} />
          </div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Share Your Fundraiser
          </h2>
          <p className="text-gray-600">
            All you need to do is share the fundraiser with your friends and
            family. Support will start pouring in.
          </p>
          <p className="text-gray-600">
            Share your fundraiser directly from the dashboard on social media.
          </p>
        </motion.div>

        {/* Step 3 */}
        <motion.div
          className="bg-white p-8 shadow-lg rounded-lg flex flex-col items-center text-center"
          variants={cardVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          transition={{ delay: 1.0 }}
        >
          <div className="w-16 h-16 flex items-center justify-center bg-yellow-100 text-yellow-600 rounded-full mb-6">
            <FaMoneyBillWave size={30} />
          </div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Withdraw Funds
          </h2>
          <p className="text-gray-600">
            The funds raised can be withdrawn without any hassle directly to
            your bank account.
          </p>
          <p className="text-gray-600">
            It takes only 5 minutes to withdraw funds on Ketto.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default FundraiserSteps;
